"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EUserStatus = void 0;
var EUserStatus;
(function (EUserStatus) {
    EUserStatus["ACTIVE"] = "active";
    EUserStatus["INACTIVE"] = "inactive";
    EUserStatus["LOCKED"] = "locked";
})(EUserStatus || (exports.EUserStatus = EUserStatus = {}));
